module.exports = __webpack_public_path__ + "img/double-queenbed.82e53558.svg";